import { Holding } from 'modules/TradesPW3/Holdings/typings';
import { ITVHolding } from 'modules/TradingChart/components/TradingView/utils/providers/brokerProvider/holdings/types';
import HoldingCalculations from 'modules/TradesPW3/Holdings/HoldingCalculations';
import HoldingsStore from 'modules/TradesPW3/Holdings/store';
import FormatService from 'modules/Format/service';

class HoldingTvFormatter {
  static formatHoldingsToTvTable = (activeHoldings: Holding[]) =>
    activeHoldings.map(holding =>
      HoldingTvFormatter.formatHoldingToTvTable(holding),
    );

  static formatHoldingToTvTable = (activeHolding: Holding): ITVHolding => {
    const holdingDetails = HoldingCalculations.generateHoldingDetails(
      activeHolding,
    );

    const exchangeToken = HoldingsStore.getPrimaryExchangeToken(activeHolding);

    const tvExchangeToken = HoldingsStore.getTvExchangeToken(activeHolding);

    const { ltp } = HoldingCalculations.getHoldingLiveData(activeHolding);

    const netAvgPrice = activeHolding.fillInfo?.demat?.avgPrice ||
      activeHolding.fillInfo?.t1?.avgPrice;

    return {
      id: activeHolding.id,
      customSymbol: activeHolding.symbol,
      symbol: tvExchangeToken,
      buyQty: holdingDetails.netQnty,
      dematQty: holdingDetails.dematQty,
      t1Qty: holdingDetails.t1Qty,
      netAvgPrice: FormatService.formatToIndianFloat(netAvgPrice || '--'),
      ltp: FormatService.formatToIndianFloat(ltp),
      investment: FormatService.formatToIndianFloat(holdingDetails.investment),
      currentValue: FormatService.formatToIndianFloat(
        holdingDetails.currentValue,
      ),
      dayPnl: holdingDetails.day,
      dayPercentage:
        holdingDetails.dayPercentage !== '--'
          ? `${holdingDetails.dayPercentage}%`
          : holdingDetails.dayPercentage,
      overallPnl: holdingDetails.overall,
      overallPercentage:
        holdingDetails.overallPercentage !== '--'
          ? `${holdingDetails.overallPercentage}%`
          : holdingDetails.overallPercentage,
      exchangeToken,
      //  Sort props
      netAvgPriceSortProp: Number(netAvgPrice),
      ltpSortProp: Number(ltp),
      investmentSortProp: Number(holdingDetails.investment),
      currentValueSortProp: Number(holdingDetails.currentValue),
      dayPnlSortProp: Number(holdingDetails.day),
      overallPnlSortProp: Number(holdingDetails.overall),
    };
  };
}

export default HoldingTvFormatter;
